<template>
  <div id="app">
    <div class="site_wrap">
      <Home id="slide_0" :gotoSlide="gotoSlide" :analytics="analytics"/>
      <ShareAsk
        id="slide_1"
        :gotoSlide="gotoSlide"
        :analytics="analytics"
        v-show="$store.state.slide >= 1"
      />
      <Share
        id="slide_2"
        :gotoSlide="gotoSlide"
        :analytics="analytics"
        v-show="$store.state.slide >= 2 && $store.state.showShare"
      />
      <ThankYou :analytics="analytics" id="slide_3" v-show="$store.state.slide >= 3"/>
    </div>
    <cookie-law theme="gu">
      <div slot-scope="props">
        <p>
          We use cookies to improve your experience using the website. You can read full details in our
          <a
            href="https://mailchimp.com/legal/privacy/"
            target="_blank"
          >privacy policy</a>. Are you happy for us to use cookies?
        </p>
        <button class="btn primary" @click="enableGA(props.accept)">
          <span>Yes</span>
        </button>
        <button class="btn primary" @click="props.close">
          <span>No</span>
        </button>
      </div>
    </cookie-law>
  </div>
</template>

<script>
import axios from "axios";
import CookieLaw from "vue-cookie-law";
import Home from "./components/Home.vue";
import ShareAsk from "./components/ShareAsk.vue";
import Share from "./components/Share.vue";
import ThankYou from "./components/ThankYou.vue";

export default {
  name: "app",
  components: {
    Home,
    ShareAsk,
    Share,
    ThankYou,
    CookieLaw
  },
  mounted() {
    if (window.location.pathname === "/video") {
      this.$store.commit("showVideo", true);
    }
    if (localStorage.getItem("cookie:accepted")) {
      // eslint-disable-next-line
      gtag("config", "UA-130527950-1", { anonymize_ip: true });
      window["ga-disable-UA-130527950-1"] = false;
    }
    axios
      .get("/thermom.php")
      .then(response => {
        console.log(response);
        this.$store.commit("setCurrentCount", response.data);
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    enableGA(accept) {
      // eslint-disable-next-line
      gtag("config", "UA-130527950-1", { anonymize_ip: true });
      window["ga-disable-UA-130527950-1"] = false;
      accept();
    },
    gotoSlide(slide, method, content) {
      console.log(content);
      switch (method) {
        case "showShare":
          this.$store.commit("showShare", true);
          break;
        case "skipShare":
          this.$store.commit("showShare", false);
          break;
      }
      this.$store.commit("gotoSlide", {
        slide: slide
      });
      setTimeout(() => {
        this.$scrollTo("#slide_" + slide, "600");
      }, 100);
    },
    analytics(action, label) {
      if (window.ga && typeof window.ga === "function") {
        // eslint-disable-next-line
        gtag("event", action, {
          event_category: "grenfell-united",
          event_label: label
        });
      }
    }
  }
};
</script>

<style lang="scss">
*,
*:before,
*:after {
  box-sizing: border-box;
}
html,
body {
  margin: 0;
  padding: 0;
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
}
h1,
h2,
h3,
h4,
h4,
.form_title {
  font-family: "Montserrat", sans-serif;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #202020;
  min-height: 100vh;
}
.Cookie--gu {
  background: #202020;
  padding: 10px;
  border-top: 2px solid #b3d234;
  > div {
    display: flex;
    max-width: 1150px;
    margin: 0 auto;
    color: #fff;
    justify-content: center;
    align-items: center;
    @media only screen and (max-width: 767px) {
      flex-wrap: wrap;
      justify-content: flex-start;
    }
    p {
      line-height: 1.5;
      margin: 0 60px 0 0;
      @media only screen and (max-width: 870px) {
        font-size: 14px;
        margin: 0 20px 0 0;
      }
      @media only screen and (max-width: 767px) {
        width: 100%;
        margin: 0 0 10px 0;
      }
    }
    a {
      color: #b3d234;
    }
    button {
      margin: 0 5px;
      padding: 10px 20px;
      min-width: 180px;
      @media only screen and (max-width: 870px) {
        font-size: 16px;
        min-width: 130px;
      }
      @media only screen and (max-width: 767px) {
        margin: 0;
        width: auto;
        &:first-of-type {
          margin-right: 10px;
        }
      }
    }
  }
}
.btn {
  background: #b3d234;
  text-align: center;
  border-radius: 4px;
  padding: 17px 30px;
  color: #fff;
  border: none;
  margin-bottom: 10px;
  font-family: "Montserrat", sans-serif;
  font-size: 20px;
  letter-spacing: 0.5px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.25s;
  min-width: 220px;
  display: inline-block;
  text-decoration: none;
  @media only screen and (max-width: 767px) {
    width: 100%;
    margin: 5px 0;
    padding: 17px 12px;
  }
  &.submit {
    width: 100%;
    background: #b3d234;
    padding: 15px 30px;
    &:hover {
      background: darken(#b3d234, 5%);
    }
  }
  &.primary {
    background: #b3d234;
    &:hover {
      background: darken(#b3d234, 5%);
    }
  }
  &.secondary {
    background: #a0a0a0;
    &:hover {
      background: darken(#a0a0a0, 5%);
    }
  }
  &.facebook {
    background: #3b5998;
    &:hover {
      background: darken(#3b5998, 5%);
    }
  }
  &.twitter {
    background: #38a1f3;
    &:hover {
      background: darken(#38a1f3, 5%);
    }
  }
  &.whatsapp {
    background: #25d366;
    display: none;
    @media only screen and (max-width: 767px) {
      display: inline-block;
    }
    &:hover {
      background: darken(#25d366, 5%);
    }
  }
}

.button_wrap {
  padding-top: 10px;
  &.pt_20 {
    padding-top: 20px;
  }
  button,
  a {
    margin: 10px;
    @media only screen and (max-width: 767px) {
      margin: 5px 0;
    }
  }
}
</style>
